module.exports = __webpack_public_path__ + "img/zg.0d014a5f.png";